module.exports = __webpack_public_path__ + "media/images/application/icons/icon-send-e339067a973eaa8d160e37479c8f6dd1.svg";